import React from 'react';
import PropTypes from 'prop-types';
var renderLabel = function renderLabel(status) {
  switch (status) {
    case 'employer_draft':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge bg-default me-5"
      }, "Employer Draft");
    case 'employer_requested_matching':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge bg-primary me-5"
      }, "Employer Requested Matching");
    case 'clora_matching':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-info me-5"
      }, "Clora Matching");
    case 'clora_matched':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-success me-5"
      }, "Matched");
    case 'executed_agreement':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-success me-5"
      }, "Executed Agreement");
    case 'work_started':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill  bg-success me-5"
      }, "Work Started");
    case 'work_completed':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-success me-5"
      }, "Work Completed");
    case 'on_hold':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-warning me-5"
      }, "On Hold");
    case 'closed':
      return /*#__PURE__*/React.createElement("span", {
        className: "badge rounded-pill bg-danger me-5"
      }, "Closed");
    case 'submitted':
      return /*#__PURE__*/React.createElement("span", {
        className: "text text-info label-text me-5"
      }, "Submitted");
    case 'edits_requested':
      return /*#__PURE__*/React.createElement("span", {
        className: "text-danger label-text me-5"
      }, "Feedback Given");
    case 'drafting':
      return /*#__PURE__*/React.createElement("span", {
        className: "text-primary label-text me-5"
      }, "In Progress");
    case 'awarded':
      return /*#__PURE__*/React.createElement("i", {
        className: "fas fa-trophy larger-trophy me-5"
      });
    case 'rejected':
      return /*#__PURE__*/React.createElement("span", {
        className: "text-muted label-text me-5"
      }, "Not Accepted");
    case 'invited':
      return /*#__PURE__*/React.createElement("span", {
        className: "text-primary label-text me-5"
      }, "Invited");
    default:
      return null;
  }
};
function ProjectStatusLabel(_ref) {
  var status = _ref.status;
  return renderLabel(status);
}
ProjectStatusLabel.propTypes = {
  status: PropTypes.string.isRequired
};
export default ProjectStatusLabel;